<div class="card">
  <div
    class="card-body align-items-center justify-content-between"
    style="gap: 1rem"
  >
    <div class="form-row">
      <div class="form-group col-md-4">
        <label for="inputState">TIPO DE DOCUMENTO 2</label>
        <select
          id="inputState"
          class="form-control texto"
          [(ngModel)]="doc_selected"
        >
          <option [value]="item.cod_causal" *ngFor="let item of docs">
            {{ item.des }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-8">
        <label for="inputZip">NUMERO DE DOCUMENTO</label>
        <input
          type="text"
          class="form-control texto"
          [(ngModel)]="n_ide"
          id="inputZip"
          (focusout)="modo_c(n_ide, doc_selected)"
        />
      </div>
    </div>
    <form *ngIf="result && mostrar === 'eveluar'">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="inputAddress">NOMBRE</label>
          <input
            type="text"
            class="form-control texto"
            id="primer_nombre"
            name="primer_nombre"
            [(ngModel)]="data.primer_nombre"
          />
        </div>
        <div class="form-group col-md-6">
          <label for="inputAddress2">APELLIDO</label>
          <input
            type="text"
            class="form-control texto"
            id="primer_apellido"
            name="primer_apellido"
            [(ngModel)]="data.primer_apellido"
          />
        </div>
        <div class="form-group col-md-6">
          <label for="inputEmail4">CORREO</label>
          <input
            type="email"
            class="form-control texto"
            id="correo"
            name="correo"
            [(ngModel)]="data.correo"
          />
        </div>
        <div class="form-group col-md-6">
          <label for="inputPassword4">TELEFONO</label>
          <input
            type="number"
            class="form-control texto"
            id="celular"
            name="celular"
            [(ngModel)]="data.celular"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="inputCity">INGRESOS</label>
          <input
            type="number"
            class="form-control texto"
            id="ingresos"
            name="ingresos"
            [(ngModel)]="data.ingresos"
          />
        </div>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="gridCheck" />
          <label class="form-check-label" for="gridCheck"> Habeas Data </label>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-12">
          <button
            type="submit"
            class="btn btn-primary btn-block"
            (click)="modo_e()"
          >
            Evaluar
          </button>
        </div>
      </div>
    </form>
    <div class="form-row" *ngIf="data && mostrar === 'detalle'">
      <div class="form-group col-md-12">
        <div
          class="alert alert-primary"
          [ngClass]="{ 'alert-danger': result.viable == 'ROJO' }"
          role="alert"
        >
          <h4 class="alert-heading">CLIENTE {{ result.viable }}</h4>
          <p>CUPO: {{ result.cupo_max }}</p>
          <p>SEGMENTO: {{ result.segmento }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- <div
    class="alert alert-danger"
    role="alert"
    *ngIf="data && data.msn_error != ''"
  >
    {{ data.msn_error }}
  </div>
  <pre>
    {{ data | json }}
  </pre>
  <pre>
    {{ result | json }}
  </pre> -->
</div>
